<div class="max-w-full">
  <div class="flex justify-between items-center mb-3">
    <h1 class="text-2xl font-semibold text-gray-900">Tipos de agente</h1>
  </div>

  <div class="bg-white rounded-lg shadow-sm overflow-hidden mt-10 mb-4">
    <table class="w-full border-collapse">
      <thead class="bg-gray-200">
        <tr>
          <th class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Tipo</th>
          <th class="px-6 py-3 text-center text-sm font-semibold text-gray-900">Transcripciones Activas</th>
          <th class="px-6 py-3 text-left text-sm font-semibold text-gray-900">Versión del Prompt</th>
          <th class="px-6 py-3 text-center text-sm font-semibold text-gray-900">Gestión</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        @for (agentType of agentTypes; track agentType.id) {
        <tr class="hover:bg-gray-50 transition-colors">
          <td class="px-6 py-4 text-sm font-medium text-gray-900">
            {{ agentType.name }}
          </td>
          <td class="px-6 py-4">
            @if (isCurrentUserAdmin()) {
            <div class="flex items-center justify-center">
              <label class="inline-flex items-center cursor-pointer" (click)="onToggleChange(agentType)">
                <input type="checkbox" [checked]="agentType.transcription_active" class="sr-only peer" (click)="$event.preventDefault()">
                <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
              </label>
            </div>
            } @else {
            <div class="flex items-center justify-center">
              @if (agentType.transcription_active) {
              <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-700">
                <svg class="w-3 h-3 mr-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clip-rule="evenodd" />
                </svg>
                Activo
              </span>
              } @else {
              <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700">
                Inactivo
              </span>
              }
            </div>
            }
          </td>
          <td class="px-6 py-4 text-sm text-gray-900">
            @if (agentType.latest_production_prompt) {
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-100 text-blue-800">
              {{ agentType.latest_production_prompt.version }}
            </span>
            } @else {
            <span class="text-gray-400 italic">Sin prompt</span>
            }
          </td>
          <td class="px-6 py-4 text-center">
            <button
              (click)="managePrompt(agentType)"
              [disabled]="!agentType.latest_production_prompt"
              [class]="agentType.latest_production_prompt 
                ? 'inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors cursor-pointer'
                : 'inline-flex items-center px-3 py-1.5 bg-gray-300 text-gray-500 text-sm font-medium rounded-md cursor-not-allowed'">
              Gestionar prompt
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<app-modal-confirm
  [isOpen]="showConfirmModal"
  [title]="'Confirmar cambio'"
  [message]="'¿Estás seguro de que quieres ' + (selectedAgentType?.transcription_active ? 'desactivar' : 'activar') + ' las transcripciones para este tipo de agente?'"
  [type]="'info'"
  [buttons]="[
    { text: 'Cancelar', style: 'secondary', action: 'cancel' },
    { text: 'Confirmar', style: 'primary', action: 'confirm' }
  ]"
  (action)="onModalAction($event)"
></app-modal-confirm>


